import styled from "styled-components";
import { Box, Flex } from "../../ppui";
import { theme } from "../../theme";

// Styled Components
export const ScreenLayout = styled.section({
    position: "fixed",
    height: "100%",
    width: "100%",
    overflow: "hidden",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    padding: "1.25rem",
    gap: "4.813rem",
    backgroundColor: theme.colors.light.light,
  });
  
export const ImageBox = styled.div({
    height: "100%",
    width: "45%",
    maxWidth: "50rem",
    overflow: "hidden",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: theme.radius.card,
    "& img": {
      width: "100%",
      height: "100%",
      objectFit: "cover",
    },
    "@media (max-width: 992px)": {
      display: "none",
    },
  });
  
export const ContentBox = styled(Flex)({
    height: "100%",
    width: "55%",
    flexGrow: 1,
    overflow: "hidden",
    flexDirection: "column",
    justifyContent: "space-between",
  });
  
  export  const Brand = styled(Flex)({
    height: "5rem",
    width: "100%",
    
    justifyContent: "flex-end",
    "& a": {
      width: "auto",
      "@media (max-width: 576px)": {
        width: "70px",
      },
    },
  });
  
export const FromBox = styled(Box)({
  width: "70%",
  overflowY: "auto",
  overflowX: "hidden",
  "@media (max-width: 992px)": {
    margin: "auto",
  },

  "@media (max-width: 576px)": {
    width: "100%",
  },
  });
  
export const FooterBox = styled(Box)({
  width: "70%",

  "@media (max-width: 992px)": {
    margin: "auto",
  },


  "@media (max-width: 576px)": {
    width: "100%",

  },
  });
  
  // Custom styles for the password toggle icon
export const PasswordToggleIcon = styled.div({
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "&:hover": {
      opacity: 0.8,
    },
  });